/* app/js/src/components/scheduler/library/library.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.scrollable-library::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-library::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.scrollable-library::-webkit-scrollbar-corner {
  background: transparent;
}
.scrollable-library::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-library::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-library::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-library::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.scrollable-library::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.scrollable-library::-webkit-scrollbar-thumb {
  border-width: 0;
}
.cursor-pointer {
  cursor: pointer;
}
.scrollable-library::-webkit-scrollbar {
  height: 11px;
  overflow: visible;
  width: 11px;
  opacity: 1;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-library::-webkit-scrollbar-button {
  height: 0;
  width: 0;
}
.scrollable-library::-webkit-scrollbar-corner {
  background: transparent;
}
.scrollable-library::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-library::-webkit-scrollbar-thumb {
  background-color: #e3e6ea;
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
  min-height: 28px;
  padding: 100px 0 0;
  border-radius: 10px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.scrollable-library::-webkit-scrollbar-thumb:hover {
  background-color: #b9bec9;
}
.scrollable-library::-webkit-scrollbar-track:hover {
  background-color: #eef2f6;
}
.scrollable-library::-webkit-scrollbar-track {
  background-clip: padding-box;
  border: solid transparent;
  border-width: 0 4px 0 4px;
}
.scrollable-library::-webkit-scrollbar-thumb {
  border-width: 0;
}
.upload-item-base,
ul .upload-new-item,
ul .upload-new-graphic-item,
ul .add-new-rule {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  max-width: calc(49% - 5px);
  min-width: calc(49% - 5px);
  width: calc(49% - 5px);
  position: relative;
}
.upload-item-base > span,
ul .upload-new-item > span,
ul .upload-new-graphic-item > span,
ul .add-new-rule > span {
  display: block;
  position: absolute;
  bottom: 7.5%;
  white-space: nowrap;
  left: 17.5%;
  width: 65%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.7em;
  letter-spacing: 0.1px;
  color: #879baf;
  text-transform: uppercase;
  text-align: center;
}
.upload-item-base button,
ul .upload-new-item button,
ul .upload-new-graphic-item button,
ul .add-new-rule button {
  background-color: #eef2f6;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  position: absolute;
  top: 5%;
  right: 5%;
  border: none;
  padding: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.upload-item-base button svg,
ul .upload-new-item button svg,
ul .upload-new-graphic-item button svg,
ul .add-new-rule button svg {
  width: 12px;
  height: 12px;
  fill: #879baf;
}
.upload-item-base button:focus,
ul .upload-new-item button:focus,
ul .upload-new-graphic-item button:focus,
ul .add-new-rule button:focus {
  outline: none;
}
.upload-item-base button:hover,
ul .upload-new-item button:hover,
ul .upload-new-graphic-item button:hover,
ul .add-new-rule button:hover {
  background-color: #879baf;
}
.upload-item-base button:hover svg,
ul .upload-new-item button:hover svg,
ul .upload-new-graphic-item button:hover svg,
ul .add-new-rule button:hover svg {
  fill: #fdfefe;
}
:host {
  position: relative;
  z-index: 1;
  overflow-x: hidden;
  overflow-y: hidden;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
:host.list-view ul {
  padding-top: 12px;
}
:host.list-view ul li,
:host.list-view ul library-item,
:host.list-view ul library-uploader,
:host.list-view ul graphic-library-item,
:host.list-view ul live-feed-library-item,
:host.list-view ul evrideo-broadcast-library-item,
:host.list-view ul evrideo-layout-library-item,
:host.list-view ul evrideo-block-library-item,
:host.list-view ul dynamic-promo-library-item {
  max-width: 100%;
  min-width: 100%;
  margin: 0 0 5px 0;
  height: 55px;
  overflow: hidden;
}
:host.list-view ul live-feed-library-item,
:host.list-view ul evrideo-layout-library-item,
:host.list-view ul dynamic-promo-library-item {
  height: 110px;
}
:host.list-view ul .upload-new-item,
:host.list-view ul .upload-new-graphic-item,
:host.list-view ul .add-new-rule {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  cursor: pointer;
}
:host.list-view ul .upload-new-item > i,
:host.list-view ul .upload-new-graphic-item > i,
:host.list-view ul .add-new-rule > i {
  width: 2em;
  height: 1em;
  margin-left: 15px;
}
:host.list-view ul .upload-new-item > i svg,
:host.list-view ul .upload-new-graphic-item > i svg,
:host.list-view ul .add-new-rule > i svg,
:host.list-view ul .upload-new-item > i[inlineSVG],
:host.list-view ul .upload-new-graphic-item > i[inlineSVG],
:host.list-view ul .add-new-rule > i[inlineSVG] {
  width: 100%;
  height: 100%;
}
:host.list-view ul .upload-new-item label,
:host.list-view ul .upload-new-graphic-item label,
:host.list-view ul .add-new-rule label {
  -ms-transform: translateY(0);
  -webkit-transform: translateY(0);
  transform: translateY(0);
  margin-bottom: 0;
  margin-left: 10px;
  color: #40c4ff;
  opacity: 0.7;
  cursor: pointer;
}
:host.list-view ul .upload-new-item > div,
:host.list-view ul .upload-new-graphic-item > div,
:host.list-view ul .add-new-rule > div {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  margin: 5px;
  padding: 0;
}
.scrollable-library {
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  margin-top: 3px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -ms-transform: translateY(-15px);
  -webkit-transform: translateY(-15px);
  transform: translateY(-15px);
}
ul li,
ul library-item,
ul library-uploader,
ul graphic-library-item,
ul live-feed-library-item,
ul evrideo-broadcast-library-item,
ul evrideo-layout-library-item,
ul evrideo-block-library-item,
ul dynamic-promo-library-item {
  margin-top: 15px;
  cursor: grab;
  max-width: calc(49% - 5px);
  min-width: calc(49% - 5px);
  height: 130px;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
ul li:nth-child(odd),
ul library-item:nth-child(odd),
ul library-uploader:nth-child(odd),
ul live-feed-library-item:nth-child(odd),
ul evrideo-broadcast-library-item:nth-child(odd),
ul evrideo-layout-library-item:nth-child(odd),
ul evrideo-block-library-item:nth-child(odd),
ul dynamic-promo-library-item:nth-child(odd) {
  margin-right: 15px;
}
ul graphic-library-item.odd {
  margin-right: 15px;
}
ul .upload-new-item,
ul .upload-new-graphic-item,
ul .add-new-rule {
  cursor: pointer;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  background-color: #ffffff;
  position: relative;
}
ul .upload-new-item > div,
ul .upload-new-graphic-item > div,
ul .add-new-rule > div {
  border: 1px dashed #c6d2df;
  position: absolute;
  top: 0;
  left: 0;
  margin: 6px 7px;
  width: 91%;
  height: 89%;
  pointer-events: none;
  opacity: 0;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
ul .upload-new-item > label,
ul .upload-new-graphic-item > label,
ul .add-new-rule > label {
  -ms-transform: translateY(20px);
  -webkit-transform: translateY(20px);
  transform: translateY(20px);
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
  margin-bottom: -1em;
  font-size: 0.9em;
  color: #c6d2df;
  opacity: 0;
}
ul .upload-new-item svg,
ul .upload-new-graphic-item svg,
ul .add-new-rule svg {
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  fill: #40c4ff;
}
ul .upload-new-item input,
ul .upload-new-graphic-item input,
ul .add-new-rule input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
ul .upload-new-item:hover > div,
ul .upload-new-graphic-item:hover > div,
ul .add-new-rule:hover > div {
  opacity: 1;
}
ul .upload-new-item:hover svg,
ul .upload-new-graphic-item:hover svg,
ul .add-new-rule:hover svg {
  -ms-transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
  fill: #c6d2df;
}
ul .upload-new-item:hover label,
ul .upload-new-graphic-item:hover label,
ul .add-new-rule:hover label {
  -ms-transform: translateY(10px);
  -webkit-transform: translateY(10px);
  transform: translateY(10px);
  opacity: 1;
}
ul .upload-new-graphic-item svg,
ul .add-new-rule svg {
  fill: #a65bfa;
}
rule-library-item {
  max-width: 48%;
  min-width: 40%;
  height: 130px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1 1 0;
  -ms-flex: 1 1 0;
  flex: 1 1 0;
  margin-top: 15px;
  margin-right: 15px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.instances-container {
  height: 0;
  visibility: collapse;
  width: 0;
  box-shadow: inset 0 0 10px 0 rgba(0, 0, 0, 0.15);
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.5s ease;
  position: relative;
  left: -15px;
  margin-top: 15px;
  padding-bottom: 15px;
  background-color: #e5eaf0;
}
.instances-container ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
  margin-top: 3px;
  float: left;
  margin-left: 5px;
  width: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.instances-container ul li,
.instances-container ul library-item,
.instances-container ul library-uploader,
.instances-container ul graphic-library-item,
.instances-container ul live-feed-library-item,
.instances-container ul evrideo-broadcast-library-item,
.instances-container ul evrideo-layout-library-item,
.instances-container ul evrideo-block-library-item,
.instances-container ul dynamic-promo-library-item {
  min-width: 40%;
  margin-top: 15px;
  max-width: 44.5%;
  height: 130px;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.instances-container ul li:nth-child(odd),
.instances-container ul library-item:nth-child(odd),
.instances-container ul library-uploader:nth-child(odd),
.instances-container ul graphic-library-item:nth-child(odd),
.instances-container ul live-feed-library-item:nth-child(odd),
.instances-container ul evrideo-broadcast-library-item:nth-child(odd),
.instances-container ul evrideo-layout-library-item:nth-child(odd),
.instances-container ul evrideo-block-library-item:nth-child(odd),
.instances-container ul dynamic-promo-library-item:nth-child(odd) {
  margin-right: 15px;
}
.instances-container.list-mode .header-instances .close-instance-box {
  margin-right: unset;
}
.instances-container.list-mode ul {
  margin-left: 15px;
  margin-top: 20px;
  width: 97%;
  flex-direction: column;
}
.instances-container.list-mode ul graphic-library-item {
  max-width: unset;
  margin-top: unset;
  margin-right: unset;
  min-width: unset;
  height: 55px !important;
  width: 100%;
  flex-basis: auto;
}
.instances-container.show {
  visibility: visible;
  height: auto;
  transform: ScaleY(1);
  min-height: 100px;
  width: auto;
  min-width: 380px;
  padding: 0 15px 0 25px;
}
.header-instances {
  font-family: "Open Sans";
  font-size: 12px;
  margin-bottom: 15px;
  margin-top: 15px;
  width: 100%;
}
.header-instances > span {
  font-weight: bold;
  color: #232f3a;
  float: left;
  margin-left: 15px;
}
.header-instances .close-instance-box {
  text-decoration: underline;
  font-family: "Open Sans";
  font-size: 12px;
  float: right;
  margin-right: 10px;
  color: #7d8fa1;
}
.header-instances .close-instance-box:hover {
  cursor: pointer;
}
marker-library-item {
  margin-bottom: 6px;
}
/*# sourceMappingURL=library.component.css.map */
